import React, { useState } from 'react'
import close from '../../assets/icons/close.svg'
import eye from '../../assets/icons/eye.svg'
import Label from '../jadwalguru/Label'
import { useDispatch, useSelector } from 'react-redux'
import { showFormError, updateFieldError, updateFieldValue } from '../../features/siswaSlice'
import { getKelas } from '../../features/kelasSlice'
import KelasSelect from "./KelasSelect";


function Form() {
    const dispatch = useDispatch()
    const { errors, nama, niy, password } = useSelector((state) => state.siswa)
    const [passwordShown, setPasswordShown] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        dispatch(updateFieldValue({ field: name, value }));

        if (value.trim() !== '') {
            dispatch(updateFieldError({
                field: name,
                error: ''
            }))
        }

        dispatch(showFormError(name))
    };

    function handleDeleteInput() {
        dispatch(updateFieldValue({ field: 'nama', value: '' }));
    }

    function handleUnhide() {
        setPasswordShown(passwordShown ? false : true);
    }

    return (
        <div className='form'>
            <div className='nama'>
                <Label className='nama' label='Nama lengkap' />
                <input
                    type="text"
                    name="nama"
                    value={nama}
                    placeholder='Masukkan nama karyawan'
                    id='nama'
                    onChange={handleInputChange}
                />
                <p className='validator-text'>
                    {errors.nama && errors.nama}
                </p>
                <img src={close} onClick={handleDeleteInput} />
            </div>

            <div className='niy'>
                <Label className='niy' label='NIY' />
                <input
                    type="number"
                    name="niy"
                    value={niy}
                    placeholder='Masukkan Nomer Induk Yayasan'
                    id='niy'
                    onChange={handleInputChange}
                />
                <p className='validator-text'>
                    {errors.niy && errors.niy}
                </p>
                <input
                    type={passwordShown ? 'text' : 'password'}
                    name="password"
                    value={password}
                    placeholder='Password'
                    id='password'
                    onChange={handleInputChange}
                />
                <img src={eye} onClick={handleUnhide} className='unhide' />
                <p className='validator-text pwd'>
                    {errors.password && errors.password}
                </p>
            </div>




            <div className='jabatan-gender'>
                <Label className='no-hp' label='Kelas' />
                <KelasSelect />
                <p className='validator-text'>
                    {errors.class_id && errors.class_id}
                </p>
            </div>

        </div>
    )
}

export default Form